import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Collaborate extends Page{
    constructor(){
        super({
            id : 'collaborate',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}